import styled from 'styled-components';
import { Checkbox } from 'antd';
import { COLORS } from '../../../theme';

export const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
`;

export const ReviewHeader = styled.div`
  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }
`;

export const CheckboxSection = styled.div`
  .ant-space-vertical {
    width: 100%;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background: #ffffff;
    }

    .ant-checkbox {
      margin-right: 8px;

      .ant-checkbox-inner {
        border-radius: 4px;
      }
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${COLORS.primary};
      border-color: ${COLORS.primary};
    }

    span:last-child {
      font-size: 14px;
      font-weight: 500;

      .ant-space {
        align-items: center;

        .anticon {
          font-size: 16px;
          color: #595959;
        }
      }
    }

    &.ant-checkbox-wrapper-checked {
      background: #f6ffed;
      border: 1px solid #b7eb8f;

      span:last-child .ant-space .anticon {
        color: ${COLORS.primary};
      }
    }
  }
`;

export const CommentInputWrapper = styled.div`
  .ant-input {
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    font-size: 13px;

    &:hover {
      border-color: #b5b5b5;
    }

    &:focus,
    &.ant-input-focused {
      border-color: ${COLORS.primary};
      box-shadow: 0 0 0 2px ${COLORS.primary}15;
    }

    &::placeholder {
      color: #bfbfbf;
      font-style: italic;
    }
  }
`;

export const SubmitSection = styled.div`
  display: flex;
  justify-content: flex-end;

  .ant-btn {
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 0 16px;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
    }
  }
`;
